export default __webpack_public_path__ + "static/media/payment.f3b9a070.svg";